// Job Detail Placeholders
export { CompanyShortPlaceholder } from './CompanyShortPlaceholder';
export { CompanyWidgetPlaceholder } from './CompanyWidgetPlaceholder';
export { DescriptionPlaceholder } from './DescriptionPlaceholder';
export { SummaryPlaceholder } from './SummaryPlaceholder';
export { TagsPlaceholder } from './TagsPlaceholder';
export { TitlePlaceholder } from './TitlePlaceholder';
